"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrBoosterCloseButton = exports.FdrBoosterWrapper = exports.FdrBoostersList = void 0;
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const styled_components_1 = __importDefault(require("styled-components"));
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
exports.FdrBoostersList = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    zIndex: 9,
    left: '50%',
    width: '100%',
    bottom: [3, 4],
    position: 'fixed',
    transform: 'translateX(-50%)',
    maxWidth: ['calc(100% - 48px)', '1170px'],
}));
exports.FdrBoosterWrapper = styled_components_1.default.div(({ theme }) => theme.boosters.boosterWrap);
exports.FdrBoosterCloseButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon)((0, util_theme_sxc_1.sx2CssThemeFn)({
    mr: [null, 3],
    backgroundColor: 'transparent',
    mt: ['6px', '16px'],
    flexShrink: '0',
    '.icon': {
        variant: [null, 'icons.lg'],
    },
}));
//# sourceMappingURL=fdr-boosters.styles.js.map